import { isNotNullOrUndefined } from '../../utility/null-safety.js';
import { Country } from './country.js';

// / ISO 4217 codes for all the supported currencies.
// / For more information see: https://en.wikipedia.org/wiki/ISO_4217
export enum Currency {
  USD = 'USD',
  EUR = 'EUR',
  RON = 'RON',
  HUF = 'HUF',
}

const currencySymbols = new Map<Currency, string>([
  [Currency.USD, '$'],
  [Currency.EUR, '€'],
  [Currency.RON, 'Lei'],
  [Currency.HUF, 'Ft'],
]);

const currencyOfCountry = new Map<Country, Currency>([
  [Country.Austria, Currency.EUR],
  [Country.Hungary, Currency.HUF],
  [Country.Romania, Currency.RON],
  [Country.Slovakia, Currency.EUR],
  [Country.Slovenia, Currency.EUR],
]);

export function getCurrencySymbol(currency: Currency): string {
  const result = currencySymbols.get(currency);
  if(isNotNullOrUndefined(result)) {
    return result;
  }

  return '$';
}

export function getCurrencyOfCountry(country: Country): Currency {
  const result = currencyOfCountry.get(country);
  if(isNotNullOrUndefined(result)) {
    return result;
  }

  throw new Error(`Failed to get currency of country: ${country}`);
}
